module.exports = "https://static.energy5.com/_next/static/images/StartNewProjectScreen-05c9163947a36765851cf46838d02514.png";